<button class="btn-empty locale-switch">
  <span
    class="h4 white-color"
    (click)="changeLanguage($event)"
  >{{ currentlocale.title | translate }}</span>
</button>
